module.exports = __webpack_public_path__ + "dd52de456e6e6171947196fbdf9cd935.pdf";